<template>
  <div class="swiper-container">
    <el-carousel :interval="4000" height="550px">
      <el-carousel-item v-for="(item, index) in homeImgList" :key="index">
        <div class="swiper-slide" :key="index">
          <img class="company_photo" :src="item.path"   />
          <div class="company_back"/>
          <div class="company_content">
            <!-- <div class="name">{{ item.name }}</div>
            <div class="desc">{{ item.desc }}</div> -->
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import constant from '../../constant/constant.js'
export default {
  data() {
    return {
      homeImgList: [],
      imgBaseURL: 'http://www.jinhui-ncm.cn/img/'
    }
  },
  computed:{
    constant() {
      return constant;
    }
  },
  created() {
    this.handleSearchImg()
  },
  methods: {
    handleSearchImg() {
      this.$axios.get('/api/bannerHeader/findList').then(res => {
        if (res.data.code = 200) {
          debugger
          this.homeImgList = res.data.map(i => {
            return {
              path: this.imgBaseURL + i.path
            }
          })
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">

  .swiper-container{
      margin-top: 5px;
      width: 100%;
      // height: 413px;
      overflow: hidden;
      .swiper-slide{
        width: 100!important;
        height: 100%;
        // height: 410px;
        background: #fff;
        border-radius: 2px;
        overflow: hidden;
        border: 1px solid #fff;
        display: flex;
        flex-direction: column;
        img{
          max-width: 100%;
          height: 100%;
          display: block;
          background-repeat: no-repeat;
          -moz-background-size:88% 88%;
          background-size:88% 88%;
          background-position: center center;
        }
      }
    }
  .company_photo{
    max-width: 100%;
    height: 100%;
    position: relative;
    opacity: 1;
  }
  .company_back {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 10001;
    display:none;
    filter:alpha(opacity=60);
    background-color: #777;
    opacity: 0.5;
    -moz-opacity: 0.5;
  }
  .company_content{
    width: 100%;
    top: 30%;
    text-align: center;
    position: absolute;
    font-size:initial;
    // width: 100%;
    flex: 1;
    padding: 0 auto;
    .name{
      font-size: 30px;
      opacity: 1;
      margin-top: 15px;
    }
    .desc{
      margin-top: 13px;
      line-height: 20px;
      font-size: 22px;
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/swiper/Customer_Home.vue